define("shared/components/shared/ui/checkbox-switch", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <label class="o--checkbox--switch" ...attributes>
    <Input @checked={{@propertyToggled}} @type="checkbox" disabled={{@isDisabled}} {{on "click" @toggleAction}} />
    <div class="o--checkbox__track {{@checkboxClass}}">
      <div class="o--checkbox__knob qa--toggle"></div>
    </div>
    {{#if @labelText}}
      <span class="o--checkbox__label {{@textClass}}" data-test-id="checkbox-label">
        {{@labelText}}
      </span>
    {{/if}}
  </label>
  */
  {
    "id": "E8tQm1id",
    "block": "[[[11,\"label\"],[24,0,\"o--checkbox--switch\"],[17,1],[12],[1,\"\\n  \"],[8,[39,0],[[16,\"disabled\",[30,2]],[4,[38,1],[\"click\",[30,4]],null]],[[\"@checked\",\"@type\"],[[30,3],\"checkbox\"]],null],[1,\"\\n  \"],[10,0],[15,0,[29,[\"o--checkbox__track \",[30,5]]]],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--checkbox__knob qa--toggle\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,6],[[[1,\"    \"],[10,1],[15,0,[29,[\"o--checkbox__label \",[30,7]]]],[14,\"data-test-id\",\"checkbox-label\"],[12],[1,\"\\n      \"],[1,[30,6]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@isDisabled\",\"@propertyToggled\",\"@toggleAction\",\"@checkboxClass\",\"@labelText\",\"@textClass\"],false,[\"input\",\"on\",\"if\"]]",
    "moduleName": "shared/components/shared/ui/checkbox-switch.hbs",
    "isStrictMode": false
  });
  /* eslint-disable ember/no-empty-glimmer-component-classes */
  /**
   * @module Components
   */
  /**
   * @class Shared::Ui::CheckboxSwitch
   * @extends Component
   *
   * This component provides a Wrapper around an HTML Input checkbox and an optional label, to quickly
   * create a properly styled checkbox-switch that can take an action to trigger when the checkbox is clicked.
   *
   * The classes "o--checkbox--switch', "o--checkbox__track", "o--checkbox_knob qa--toggle", and "o--checkbox__label"
   * are applied to the elements in the component for styling.
   *
   * Arguments:
   * - [class] (String) The class added to style the HTML container for the input checkbox and label.
   * - [isDisabled] (Boolean) Whether or not the input is disabled (default: false)
   * - [labelText] (String) is an optional value, if there is a value than a span class will be made with the labelText value
   * - [propertyToggled] (Boolean) The state at which the input is toggled true or false.
   * - [textClass] (String) The class added to style the labelText value.
   * - [toggleAction] (action/task) Click handler for input checkbox, used in the @click property.
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Ui::CheckboxSwitch @propertyToggled={{toggled}} @toggleAction={{action @toggleCheckbox}} />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::Ui::CheckboxSwitch
   *  @class="u--p__0 u--m__b"
   *  @isDisabled={{true}}
   *  @labelText={{t " calendar.settings.calendar_notes_label"}}
   *  @propertyToggled={{toggled}}
   *  @textClass="u--text--black u--text--bold"
   *  @toggleAction={{action @toggleCheckbox}}
   * />
   * ```
   */
  class CheckboxSwitchComponent extends _component2.default {}
  _exports.default = CheckboxSwitchComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckboxSwitchComponent);
});